

















































































































import MAFDropdown from '../common/MAFDropdown.vue';
import { friendState } from '../../store/Friends';
import {Lookup, LookupIcon} from '@/store/types';
import {Prop, Emit, Ref, Vue, Watch} from 'vue-property-decorator';
import AdminNavBar from './AdminNavBar.vue';
import Component, {mixins} from 'vue-class-component';
import {MAFUser} from '@/store/User/types';
import {Action, Mutation, namespace, Getter, State} from 'vuex-class';
import {modalTemplate} from '@/components/common/types';
import BTable from 'buefy/src/components/table/Table.vue';
import luxon from '@/plugins/luxon';
import {DateTime} from 'luxon';
import * as _ from 'lodash';
import {MAFViolation} from '@/store/Violations/types';
import * as firebase from 'firebase/app';
import BModal from 'buefy/src/components/modal/Modal.vue';
import ModalTemplate from '@/components/common/ModalTemplate.vue';
import BanUserModal from './BanUserModal.vue';
import EditUserModal from './EditUserModal.vue';
import ArchiveUserModal from './ArchiveUserModal.vue';
import GeoPoint = firebase.firestore.GeoPoint;
import ProfileUpdateModal from '../../components/Modals/ProfileModals/ProfileUpdateModal.vue';
import CoinFooter from '@/components/Modals/CoinModals/CoinFooter.vue';
import AvatarCreator from '@/components/SignUp/AvatarCreator.vue';
import UploadModal from '@/components/SignUp/UploadModal.vue';

/* tslint:disable:max-line-length */

const violationPath = 'violationState';
const violationNamespace = namespace(violationPath);
const userPath = 'userState';
const userNamespace = namespace(userPath);

@Component({
        components: {
            AdminNavBar,
            BTable, BanUserModal, ModalTemplate, BModal,
            EditUserModal, ArchiveUserModal, ProfileUpdateModal,
            CoinFooter, AvatarCreator, UploadModal,
        },
    })

 export default class AdminUsers extends Vue {
    @Ref('profileModal') public profileModal!: modalTemplate;
    @violationNamespace.State('allUsers') public Users !: MAFUser[];
    @violationNamespace.Action('getAllUsers') public getAllUsers!: any;
    @userNamespace.Action('setUserAdmin') public setUserAdmin: any;

    public currentPage: number = 1;
    public checkboxPosition: any = 'left';
    public hasMobileCards: boolean = true;
    public showInteraction: boolean = false;
    public defaultSortDirection: any = 'asc';
    public showBan: boolean = false;
    public showProfile: boolean = false;
    public showArchive: boolean = false;
    public showUploadModal: boolean = false;
    public showAvatarCreator: boolean = false;
    public selectedUser: any = [];
    public BASE_URL: string;
    public genUserFilter: boolean = false;
    public parentFilter: boolean = false;
    public organizationFilter: boolean = false;
    public allUserFilter: boolean = true;
    public dataTab: any;
    constructor() {
        super();
        this.BASE_URL = process.env.BASE_URL ? process.env.BASE_URL : '';
    }
    public async created() {
        await this.getAllUsers();
    }
    public formatDate(date: Date) {
        return DateTime.fromJSDate(date).toFormat(' LLLL d yyyy t');
    }
    public capitalize(name: string, userType: string) {
        if (userType === 'Organization') {
            return name;
        } else {
            const nameArray = name.split(' ');
            const firstName = nameArray[0];
            if (nameArray.length === 1) {
                return firstName;
            }
            return `${firstName} ${(nameArray.length > 1 && nameArray[1].length > 0) ? nameArray[1][0] + '.' : ''}`;
        }
    }
    public setCoord(location: GeoPoint) {
        const lat = location.latitude;
        const long = location.longitude;
        const coordArray = [lat, long];
        return coordArray;

    }
    public getData() {
        if (this.allUserFilter) {
            return this.Users;
        } else if (this.genUserFilter) {
            if (this.Users) {
                const user = 'General User';
                const user2 = 'Me and Caregiver';
                const user3 = 'Me and Parents';
                const user4 = 'Me';
                return this.Users.filter((u) => u.userType === user || u.userType === user2 || u.userType === user3 || u.userType === user4);
            }
        } else if (this.parentFilter) {
            if (this.Users) {
                const parent = 'Parent/Caregiver';
                const par2 = 'A Caregiver';
                const par3 = 'My Parents';
                return this.Users.filter((u) => u.userType === parent || u.userType === par2 || u.userType === par3);
            }
        } else if (this.organizationFilter) {
            if (this.Users) {
                return this.Users.filter((u) => u.userType === 'Organization');
            }
        }
    }
    public filterTable(userType: string) {
        if (userType === 'all') {
            this.parentFilter = false;
            this.genUserFilter = false;
            this.organizationFilter = false;
        } else if (userType === 'genUsers') {
            this.parentFilter = false;
            this.organizationFilter = false;
            this.allUserFilter = false;
        } else if (userType === 'parents') {
            this.allUserFilter = false;
            this.organizationFilter = false;
            this.genUserFilter = false;
        } else if (userType === 'organizations') {
            this.allUserFilter = false;
            this.genUserFilter = false;
            this.parentFilter = false;
        }
    }
    public closeBan() {
        this.showBan = false;
    }
    public openBan(user: MAFUser) {
        this.showBan = true;
        this.selectedUser = user;
    }
    public async saveProfile() {
        await this.profileModal.save();
        this.closeProfile();
    }
    public closeProfile() {
        this.showProfile = false;
    }
    public openEdit(user: MAFUser) {
        this.showProfile = true;
        this.selectedUser = user;
    }
    public goToModal(where: string, close: string) {
        if (this.hasOwnProperty(close)) {
            // @ts-ignore
            this[close] = false;
        }

        // workaround for Mike's popup transitions
        if (where === 'showUploadModal') {
            this.showUploadModal = true;
        } else if (where === 'showAvatarCreator') {
            this.showAvatarCreator = true;
        }
    }
    public closeArchive() {
        this.$router.push('/admin/users');
    }
    public openArchive() {
        this.showArchive = true;
    }
    public data() {
        return {
            showDetailIcon: true,
            checkable: true,
        };
    }
    public updateAvatar(rowUser: MAFUser) {
        if (rowUser.userType && rowUser.userType === 'Organization') {
            return '../../img/organizations/profile_org@2x.png';
        } else {
            if (rowUser && rowUser.avataarUrl && rowUser.avataarUrl !== '') {
                return rowUser.getAvataarUrl(this.BASE_URL, true);
            }
            if (rowUser && rowUser.imageURL !== '') {
                return rowUser.imageURL;
            }
            return rowUser.getAvataarUrl(this.BASE_URL, true);
        }
    }
     /* tslint:disable:no-console */
    public async openAdmin(user: MAFUser) {
        if (!user.Reference) {
                const userDocumentRef = Vue.prototype.$firestore.collection('users').doc(user.uid);
                user.setDocumentReference(userDocumentRef);
            }
        try {
            await this.setUserAdmin(user);

        } catch (error) {
            console.log(error);
        }
    }

 }
